// 전체코드
// src/pages/course/AddCoursePage.js

import React, { useState } from "react";
import { useNavigate } from "react-router-dom";

import CourseMapView from "../../components/course/CourseMapView";
import CourseCreateForm from "../../components/course/CourseCreateForm";
import BackButton from "../../components/common/BackButton";
import { startAddingCourse } from "../../api/courseApi";
import { useJWT } from "../../contexts/JWTContext";
import { useToast } from "../../contexts/ToastContext";

const DRAFT_KEY_PREFIX = "wingstep_course_adding_draft";

function getDraftKey(userId) {
  return `${DRAFT_KEY_PREFIX}:${userId || "unknown"}`;
}

function saveDraft(userId, draft) {
  try {
    localStorage.setItem(getDraftKey(userId), JSON.stringify(draft));
  } catch (e) {}
}

function AddCoursePage() {
  const [courseType, setCourseType] = useState("러닝");
  const [courseName, setCourseName] = useState("");

  const navigate = useNavigate();
  const { userId } = useJWT();
  const { showToast } = useToast();

  const handleStart = async () => {
    if (!courseType) {
      showToast("유형을 선택해 주세요.", "w");
      return;
    }

    if (!courseName || courseName.trim() === "") {
      showToast("코스 이름을 입력해 주세요.", "w");
      return;
    }

    try {
      const workRecordId = await startAddingCourse(userId, courseType);

      // 생성중 복구를 위해 localStorage에 임시 저장
      saveDraft(userId, {
        workRecordId,
        type: courseType,
        courseName: courseName.trim(),
        savedAt: Date.now(),
      });

      // state가 사라져도(localStorage로 복구) 동작하도록 workRecordId는 반드시 넘김
      navigate("/course/adding", {
        state: {
          workRecordId,
          // 있으면 즉시 UI에 쓰고, 없어도 localStorage로 복구 가능
          type: courseType,
          courseName: courseName.trim(),
        },
      });
    } catch (error) {
      console.error("코스 생성 시작 실패:", error);
      showToast("코스 생성 시작 중 오류가 발생했습니다.", "e");
    }
  };

  return (
    <div className="h-screen overflow-hidden bg-gray-50 flex flex-col max-w-md mx-auto relative font-sans">
      <header className="px-5 pt-6 pb-4 bg-white sticky top-0 z-20 flex items-center justify-between shadow-sm">
        <div className="w-8">
          <BackButton />
        </div>
        <h1 className="text-xl font-bold text-gray-800">코스 생성</h1>
        <div className="w-8" />
      </header>

      <main className="flex-1 overflow-y-auto px-5 py-6 pb-20 scrollbar-hide space-y-6">
        <section className="bg-white rounded-[24px] overflow-hidden shadow-[0_8px_30px_rgb(0,0,0,0.04)] border border-gray-100">
          <div className="relative h-64 w-full">
            <CourseMapView />
          </div>
        </section>

        <CourseCreateForm
          type={courseType}
          onTypeChange={setCourseType}
          courseName={courseName}
          onCourseNameChange={setCourseName}
          onStart={handleStart}
        />
      </main>
    </div>
  );
}

export default AddCoursePage;
